import {
    ListUsingGet12Params,
    OpChannelInfoVo,
    ExportChannelUsingGetParams,
    InfoUsingGetParams,
    OpChannelAuditParam,
    BindDockingPeopleVo,
    CoChannel,
    UpdateFixedCityParam,
    QueryMyChannelForLogisticsUsingGet1Params,
    MyPartnerForRestrictDistribution,
    QuickOrderGuideVo
} from '@servicesTypings/drpRequest'
import {
    ShopTypeCountVo,
    ListUsingGet5Params,
    GylErpShopInfo8,
    GetViewAllSupplierConfigUsingGetParams,
    ViewAllSupplierConfigVo
} from '@servicesTypings/companyRequest'
import { companyRequest, drpRequest } from '@/utils/request'

import { MySupplierSimpleParam, QueryRiskDeliveryResult } from '@servicesTypings/drpRequestV3'

/**
 * 获取列表
 */
export function queryChannel(params: ListUsingGet12Params): API.Res<OpChannelInfoVo[]> {
    return drpRequest.get('/op/channel/list', { params })
}

// 查询每个商家所拥有店铺的平台集合
/**
 * 查询每个商家所拥有店铺的平台集合
 */
export function getShopTypeCount(data: string): API.Res<ShopTypeCountVo[]> {
    return companyRequest.post('/op/erpShopInfo/getShopTypeCount', { data })
}

// 导出分销商Excel
/**
 * 导出分销商Excel
 */
export function exportChannel(params: ExportChannelUsingGetParams): API.Res<object> {
    return drpRequest.get('/companyStatistics/exportChannel', { params })
}

/**
 * 获取单个渠道信息
 */
export function fetchDetail(params: InfoUsingGetParams): API.Res<OpChannelInfoVo> {
    return drpRequest.get('/op/channel/info', { params })
}

/**
 * 审核
 */
export function updateAuthInfo(data: OpChannelAuditParam): API.Res<object> {
    return drpRequest.post('/op/channel/audit', { data })
}

// 修改对接运营信息
/**
 * 修改对接运营信息
 */
export function updateChannel(data: BindDockingPeopleVo): API.Res<string> {
    return drpRequest.post('/op/channel/updateDockingPeopleInfo', { data })
}

// 修改对接BD人员信息
/**
 * 修改对接BD人员信息
 */
export function updateDockingBdInfo(data: BindDockingPeopleVo): API.Res<string> {
    return drpRequest.post('/op/channel/updateDockingBdInfo', { data })
}

// 设置渠道权重
/**
 * 更新渠道权重
 */
export function setWeightApi(data: OpChannelInfoVo): API.Res<object> {
    return drpRequest.post('/op/channel/updateChannelWeights', { data })
}

// 更新分销商剩余可申请合作次数
/**
 * 更新分销商剩余可申请合作次数
 */
export function updateMaxApplyCooperationNum(data: OpChannelInfoVo): API.Res<object> {
    return drpRequest.post('/op/channel/updateMaxApplyCooperationNum', { data })
}

// 获取店铺列表
/**
 * 查询商家店铺信息列表
 */
export function getShopListApi(params: ListUsingGet5Params): API.Res<GylErpShopInfo8[]> {
    return companyRequest.get('/erpShopInfo/list', { params })
}

// 获取展示全部商家菜单配置
/**
 * 查询展示全部商家菜单配置
 */
export function fetchViewAllSupplierConfig(
    params: GetViewAllSupplierConfigUsingGetParams
): API.Res<ViewAllSupplierConfigVo> {
    return companyRequest.get('/op/erpShopInfo/getViewAllSupplierConfig', { params })
}

// 修改展示全部商家菜单手动开放状态
/**
 * 修改展示全部商家菜单手动开放状态
 */
export function updateViewAllSupplierApi(data: CoChannel): API.Res<object> {
    return drpRequest.post('/op/channel/updateViewAllSupplier', { data })
}

// 修改对接备注
/**
 * 修改对接备注
 */
export function updateChannelRemark(data: OpChannelInfoVo): API.Res<string> {
    return drpRequest.post('/op/channel/updateRemark', { data })
}

// 更新分销商修正城市
/**
 * 更新分销商修正城市
 */
export function updateChannelFixedCityApi(data: UpdateFixedCityParam): API.Res<object> {
    return drpRequest.post('/op/channel/updateChannelFixedCity', { data })
}

// 查询全部分销小站市
/**
 * 查询全部分销商修正城市
 */
export function queryAllChannelFixedCity(): API.Res<string[]> {
    return drpRequest.get('/op/channel/queryAllChannelFixedCity')
}

// 查询合作中的分销商(物流限定分销商用)
/**
 * 查询合作中的分销商(物流限定分销商用)
 */
export function myChannelForLogistics(
    params: QueryMyChannelForLogisticsUsingGet1Params
): API.Res<MyPartnerForRestrictDistribution[]> {
    return drpRequest.get('/myPartner/myChannelForLogistics', { params })
}

// 获取分销商引导接口
/**
 * 极速出单引导
 */
export function queryQuickOrderGuide(): API.Res<QuickOrderGuideVo> {
    return drpRequest.get('/channel/quickOrderGuide')
}

// 更新结束极速推单引导
/**
 * 结束极速出单引导
 */
export function updateEndQuickOrderGuide(): API.Res<null> {
    return drpRequest.post('/channel/endQuickOrderGuide')
}

/**
 * undefined
 */
export function queryRiskDelivery(data: MySupplierSimpleParam): API.Res<QueryRiskDeliveryResult[]> {
    return drpRequest.post('/mySupplier/queryRiskDelivery', { data })
}
